// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"4485a8d8","152":"29128fbb","284":"4485a8d8","487":"4485a8d8","704":"3e0edb55","707":"3e0edb55","722":"4485a8d8","752":"4485a8d8","952":"3904e224","967":"4485a8d8"}[chunkId] + ".chunk.css";
};